
// Autogenerated from file 'WarlockStaticsGen.tt'. DO NOT MODIFY
// =============================================================================
// Yodiwo Warlock Statics API
// =============================================================================
export module WarlockStatics {
  export namespace WarlockAPI {
    export const s_StorageUploadReq: string = "storageuploadreq";
	export const s_StorageReplaceReq: string = "storagereplacereq";
	export const s_BRDUpdateReq: string = "brdupdatereq";
	export const s_StorageUploadResp: string = "storageuploadresp";
	export const s_GenericRsp: string = "genericrsp";
  }
}
